import React, { useState } from 'react';
import { FaCalculator, FaInfoCircle } from 'react-icons/fa';
import FormulasExplanation from '../FormulasExplanation';

const Header = () => {
  const [isFormulasModalOpen, setIsFormulasModalOpen] = useState(false);

  return (
    <header className="bg-gradient-to-r from-blue-600 to-blue-800 text-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row md:justify-between md:items-center">
        <div className="flex items-center mb-4 md:mb-0">
          <FaCalculator className="text-3xl mr-2" />
          <h1 className="text-2xl font-bold">Standard Repayment Calculations</h1>
        </div>
        
        <button 
          onClick={() => setIsFormulasModalOpen(true)}
          className="flex items-center px-4 py-2 bg-white text-blue-700 rounded-md hover:bg-blue-50 transition-colors cursor-pointer"
        >
          <FaInfoCircle className="mr-2" />
          <span>View Formulas</span>
        </button>
      
        <FormulasExplanation 
          isOpen={isFormulasModalOpen}
          onClose={() => setIsFormulasModalOpen(false)}
        />
      </div>
      
      <div className="bg-blue-900 py-2">
        <div className="container mx-auto px-4">
          <p className="text-sm text-blue-100">
            A comprehensive tool for understanding loan repayments, missed payments, interest accrual, and restructuring options.
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header;